import {
    GET_COUNTPERSONS, GET_COUNTVEHICULE,
    GET_ERROR_COUNTPERSONS, GET_ERROR_COUNTVEHICULE,
    LOADING_COUNTPERSONS, LOADING_COUNTVEHICULE,
    RESET_STATE_DASHBOARD, SET_VALUESKIN
} from "../../actionsType/dashboard/dashboardActionType"

const INITIAL_STATE = {
    loading_countPerson: false,
    error_countPerson: null,
    success_countPerson: null,
    loading_countVehicule: false,
    error_countVehicule: null,
    success_countVehicule: null,
    valueSkin: null
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case RESET_STATE_DASHBOARD:
            return {
                ...state,
                loading_countPerson: false,
                error_countPerson: null,
                loading_countVehicule: false,
                error_countVehicule: null
            }

        case GET_COUNTPERSONS:
            return {
                ...state,
                loading_countPerson: false,
                error_countPerson: null,
                success_countPerson: action.payload
            }
        case LOADING_COUNTPERSONS:
            return {
                ...state,
                loading_countPerson: true,
                error_countPerson: null,
                success_countPerson: null
            }
        case GET_ERROR_COUNTPERSONS:
            return {
                ...state,
                error_countPerson: action.payload,
                loading_countPerson: false
            }

        case SET_VALUESKIN:
            return {
                ...state,
                valueSkin: action.payload
            }

        case GET_COUNTVEHICULE:
            return {
                ...state,
                loading_countVehicule: false,
                error_countVehicule: null,
                success_countVehicule: action.payload
            }
        case LOADING_COUNTVEHICULE:
            return {
                ...state,
                loading_countVehicule: true,
                error_countVehicule: null,
                success_countVehicule: null
            }
        case GET_ERROR_COUNTVEHICULE:
            return {
                ...state,
                error_countVehicule: action.payload,
                loading_countVehicule: false
            }
        default:
            return state
    }
}
